import { useTranslation } from 'react-i18next';

import { Sasquatch } from './Illustrations/Sasquatch';
import { StatusPage } from './StatusPage';

export const PageNotFound = () => {
	const { t } = useTranslation('monarch');

	return (
		<StatusPage
			graphic={<Sasquatch title={t('status.missing_image_title')} />}
			heading={t('status.not_found_title')}
			subheading={t('status.not_found_description')}
			status={404}
		/>
	);
};
